export default __webpack_public_path__ + "f49a8171afef979ea61dc0c240c3ff0c.jpg";